import type { FaireProductEntity } from "../../entity_types/product";

export const p_c3t8anqg4b: FaireProductEntity = {
  token: "p_c3t8anqg4b",
  type: "product",
  name: "Spooky Recipes Daily Tote",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/25502567733280ada4c3bd01b0e92c9da7b5c5c27c41b7a92ce2ea3b140efb64.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ca35b4484f48c7b76697bca73f86238437405a9a73dea72d318a429657ac1c41.jpeg",
    "https://cdn.faire.com/fastly/b1a4bdf1646e43d96ce09ebeab44888c4d19da0890e4bf0cba633514a6ad3365.jpeg",
    "https://cdn.faire.com/fastly/7b2a2a1566ea65fe6da3af0e29c5630ca9c091abc5576e32360da76785184766.jpeg"
  ],
  priceDollars: 4,
  description: "A reusable daily tote from our Halloween Collection featuring a double-sided design displaying fun seasonal recipes replicated from original hand illustrated art. Homestead Halloween recipe designs feature steps for making both graveyard pudding and caramel apples with coordinating illustrations. Recipe tote gussets display a dark brown gingham pattern. Our Spooky Recipes tote bag is made from eco-friendly post-consumer material and includes complementing brown nylon straps. Seasonal tote folds flat for convenient storage. A homestead Halloween tote perfect for a seasonal accessory or great for reusable gift wrapping.",
  tags: [],
  msrpDollars: 7.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:29.263Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
